<template>
  <v-container fluid>
    <v-row v-if="catalogId">
      <v-col cols="12">
        <v-card>
          <v-toolbar color="secondary" dark>
            <v-toolbar-title>
              <v-icon left>mdi-clipboard-text</v-icon>Catalogs
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-dialog v-model="exportPopup" max-width="980px">
                <template #activator="{on}">
                  <v-btn text v-on="on">
                    <v-icon class="mr-2">mdi-cloud-download</v-icon>Export
                  </v-btn>
                </template>
                <v-card :disabled="loading" :loading="loading">
                  <v-card-title>
                    <span class="headline">Export Catalog</span>
                  </v-card-title>
                  <v-card-text v-if="catalog">
                    <template v-if="catalog.exportFilename">
                      The latest export of catalog is :
                      <strong>{{ catalog.exportFilename }}</strong>
                      <download
                        label="Download this export"
                        url="catalogs/export"
                        :filename="catalog.exportFilename"
                        :data="{ catalogId: catalogId }"
                      ></download>
                      <v-btn text @click="orderExport()">
                        <v-icon class="mr-2">mdi-cloud-download</v-icon>Generate a new export
                      </v-btn>
                    </template>
                    <template v-else>Please come back later to download the new export</template>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <import-price :catalogId="catalogId"></import-price>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-expansion-panels>
              <v-expansion-panel v-for="productType in this.types" :key="productType" class="mb-4">
                <v-expansion-panel-header>{{productType}}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text class="grey lighten-3">
                      <v-card class="mb-2">
                        <v-card-title>Sets</v-card-title>
                        <set-list
                          store="productSets/index"
                          :headers="headers"
                          :filters="{ classification: productType, catalogId: catalogId }"
                          :displaySearch="false"
                        ></set-list>
                      </v-card>
                      <v-card class="mt-2">
                        <v-card-title>Orphan Products</v-card-title>
                        <product-list
                          store="products/index"
                          :headers="productHeaders"
                          :filters="{
                            classification: productType,
                            catalogId: catalogId,
                            setId: null
                          }"
                          :displaySearch="false"
                          hide-default-footer
                        ></product-list>
                      </v-card>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
      
</template>
<script>
import Download from "@components/Download.vue";
import ProductList from "@components/products/ProductList.vue";
import SetList from "@components/productSet/SetList.vue";
import ImportPrice from "@components/products/ImportPrice.vue";
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    ProductList,
    SetList,
    ImportPrice,
    Download
  },

  data : () => ({
      headers: [
        { text: "", value: "validity", align: "left" },
        { text: "Name", value: "name", align: "left" },
        { text: "Dominant Hand", value: "dominantHand" },
        { text: "Availability", value: "particleList" },
        { text: "Total Stock", value: "totalStock" },
        { text: "", value: "actions" }
      ],
      productHeaders: [
        { text: "Sku", value: "sku", align: "left" },
        { text: "Set", value: "set.name", align: "left" },
        { text: "Name", value: "name", align: "left" },
        { text: "Brand", value: "brand", align: "left" },
        { text: "", value: "actions" }
      ],
      types: [],
      exportPopup: false
  }),

  computed: {
    ...mapGetters('catalogs', ['catalogs', 'loading']),
    catalogId: function() {
      return  parseInt(this.$route.params.id)
    },
    filters: function() {
      return {
        catalogId:this.catalogId
      };
    },
    catalog: function() {
      return this.catalogs.find(catalog => catalog.id == this.catalogId);
    }
  },
  mounted() {
    this.fetchProductTypes();
    this.getCatalogs();
    
  },
  methods: {
    ...mapActions('catalogs', ['getCatalogs', 'scheduleExport']),
    ...mapActions("products", ['getProductTypes']),
    fetchProductTypes() {
        this.getProductTypes({
          catalogId: this.catalogId
        })
        .then(data => {
          this.types = data.types;
        })
    },
    orderExport() {
      this.scheduleExport({
          id: this.catalogId
        })
        .then(data => {
          /*const idx = this.catalogs.findIndex(catalog => catalog.id == this.catalogId);
          this.catalogs[idx] = data.catalog*/

          this.catalog.exportFilename = data.catalog.exportFilename
        });
    }
  },
  
};
</script>
